// Updated GSAP ScrollTrigger script for all sections
// Make sure GSAP and ScrollTrigger are loaded before this script

// Wait until DOM is fully loaded
function initMainCollectionAnimations() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  // === SECTION 1: Main Collection Animations ===
  const mainCollection = document.querySelector(".s-main-collection");
  if (mainCollection) {
    const productCards = document.querySelectorAll(".s-main-collection__list .c-product-card");
    const mainHeader = document.querySelector(".s-main-collection__header");

    // Section fade-out on scroll past
    gsap.fromTo(
      mainHeader,
      { opacity: 1, y: 0 },
      {
        opacity: 0,
        y: -60,
        ease: "power2.out",
        scrollTrigger: {
          trigger: mainHeader,
          start: "bottom 40%",
          end: "bottom top",
          scrub: true
        }
      }
    );
  
    // Animate Header
    // if (mainHeader) {
    //   gsap.fromTo(
    //     mainHeader,
    //     { opacity: 0, y: 40 },
    //     {
    //       opacity: 1,
    //       y: 0,
    //       duration: 0.6,
    //       ease: "power2.out",
    //       scrollTrigger: {
    //         trigger: mainHeader,
    //         start: "top 90%",
    //         toggleActions: "play reverse play reverse",
    //       }
    //     }
    //   );
    // }
  
    // Animate Product Cards (fade + slide up, reversible)
    productCards.forEach((card) => {
      gsap.fromTo(card,
        { opacity: 0, y: 60, x: 0, rotate: 0 },
        {
          opacity: 1,
          y: 0,
          duration: 0.6,
          ease: "power2.out",
          overwrite: 'auto',
          clearProps: 'transform',
          scrollTrigger: {
            trigger: card,
            start: "top 80%",
            toggleActions: "play reverse play reverse",
          }
        }
      );
    });
  }

  // === SECTION 2: Cat Nap Spot Animations ===
  const catNapSection = document.querySelector(".s-cat-nap-spot");
  if (catNapSection) {
    const title = catNapSection.querySelector(".s-cat-nap-spot__title");
    const description = catNapSection.querySelector(".s-cat-nap-spot__description");
    const imageMob = catNapSection.querySelector(".s-cat-nap-spot__image--mob");
    const imageDesk = catNapSection.querySelector(".s-cat-nap-spot__image--desk");
    const button = catNapSection.querySelector(".s-cat-nap-spot__link");
    const textBlock = catNapSection.querySelector(".s-cat-nap-spot__text-block");
  
    // Animate title
    if (title) {
      gsap.fromTo(
        title,
        { x: -30, opacity: 0 },
        {
          x: 0,
          opacity: 1,
          duration: 0.6,
          ease: "power2.out",
          scrollTrigger: {
            trigger: title,
            start: "top 80%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }
  
    // Animate description
    if (description) {
      gsap.fromTo(
        description,
        { x: -30, opacity: 0 },
        {
          x: 0,
          opacity: 1,
          duration: 0.6,
          delay: 0.2,
          ease: "power2.out",
          scrollTrigger: {
            trigger: description,
            start: "top 80%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }
  
    // Animate images
    [imageMob, imageDesk].forEach((img) => {
      if (!img) return;
      gsap.fromTo(
        img,
        { y: 30, opacity: 0 },
        {
          y: 0,
          scale: 1,
          opacity: 1,
          duration: 0.8,
          ease: "power2.out",
          scrollTrigger: {
            trigger: img,
            start: "top 80%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    });
  
    // Animate button pop-in
    if (button) {
      gsap.fromTo(
        button,
        { scale: 0.95, opacity: 0 },
        {
          scale: 1,
          opacity: 1,
          duration: 0.5,
          ease: "back.out(1.7)",
          scrollTrigger: {
            trigger: button,
            start: "top 80%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }

    // Animate text block
    if (textBlock) {
      gsap.fromTo(
        textBlock,
        { x: -30, opacity: 0 },
        {
          x: 0,
          opacity: 1,
          duration: 0.6,
          delay: 0.2,
          ease: "power2.out",
          scrollTrigger: {
            trigger: textBlock,
            start: "top 80%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }
  }

  // === SECTION 3: Feature Slider Animations ===
  const featureSlider = document.querySelector(".s-feature-slider");
  if (featureSlider) {
    const title = featureSlider.querySelector(".s-feature-slider__title");
    const slides = featureSlider.querySelectorAll(".s-feature-slider__slide");

    gsap.fromTo(
      featureSlider,
      { opacity: 1, y: 0 },
      {
        opacity: 0,
        y: -60,
        ease: "power2.out",
        scrollTrigger: {
          trigger: featureSlider,
          start: "bottom 40%",
          end: "bottom top",
          scrub: true
        }
      }
    );

    if (title) {
      gsap.fromTo(title,
        { x: -30, opacity: 0 },
        {
          x: 0,
          opacity: 1,
          duration: 0.6,
          ease: "power2.out",
          scrollTrigger: {
            trigger: featureSlider,
            start: "top 80%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }

    slides.forEach((slide, index) => {
      gsap.fromTo(slide, { y: 40, opacity: 0 }, {
        y: 0,
        opacity: 1,
        duration: 0.6,
        delay: index * 0.1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: slide,
          start: "top 80%",
          toggleActions: "play reverse play reverse"
        }
      });
    });
  }

  // === SECTION 4: Subscription Section Animation ===
  const subscriptionSection = document.querySelector('.s-subscription');
  if (subscriptionSection) {
    const title = subscriptionSection.querySelector('.s-subscription__title');
    const description = subscriptionSection.querySelector('.s-subscription__description');
    const form = subscriptionSection.querySelector('.s-subscription__form');
    const imageWrapper = subscriptionSection.querySelector('.s-subscription__image-wrapper');
    const subscribeButton = subscriptionSection.querySelector('.s-subscription__button');
  
    // Fade up & stagger for text + form (repeatable)
    if (subscriptionSection && title && description && form) {
      const fadeItems = [title, description, form];

      fadeItems.forEach((el, i) => {
        const delay = i * 0.2;

        gsap.fromTo(el,
          { y: 20, opacity: 0 },
          {
            y: 0,
            opacity: 1,
            duration: 0.6,
            delay,
            ease: 'power2.out',
            scrollTrigger: {
              trigger: el,
              start: 'top 90%',
              toggleActions: 'play reverse play reverse',
              onEnter: () => {},
            }
          }
        );
      });
    }
  
    // Cat illustration animation (repeatable)
    if (imageWrapper) {
      gsap.fromTo(
        imageWrapper,
        { x: 40, opacity: 0, scale: 0.9 },
        {
          x: 0,
          opacity: 1,
          scale: 1,
          duration: 0.8,
          ease: 'elastic.out(1, 0.4)',
          scrollTrigger: {
            trigger: imageWrapper,
            start: 'top 80%',
            end: 'bottom 0%',
            toggleActions: 'play reverse play reverse',
          },
        }
      );
    }

    // Animate button pop-in (Subscribe)
    if (subscribeButton) {
      gsap.fromTo(
        subscribeButton,
        { scale: 0.95, opacity: 0 },
        {
          scale: 1,
          opacity: 1,
          delay: 0.5,
          duration: 0.5,
          ease: "back.out(1.7)",
          scrollTrigger: {
            trigger: subscribeButton,
            start: "top 80%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }
  }

  // === SECTION 5: Catalog Download Animation ===
  const catalogSection = document.querySelector('.s-catalog-download');

  if (catalogSection) {
    const title = catalogSection.querySelector('.s-catalog-download__title');
    const text = catalogSection.querySelector('.s-catalog-download__text');
    const button = catalogSection.querySelector('.why-us-section__link');

    // Section fade-out
    gsap.fromTo(
      catalogSection,
      { opacity: 1, y: 0 },
      {
        opacity: 0,
        y: -60,
        ease: "power2.out",
        scrollTrigger: {
          trigger: catalogSection,
          start: "bottom 40%",
          end: "bottom top",
          scrub: true
        }
      }
    );

    // Title animation
    if (title) {
      gsap.fromTo(
        title,
        { y: -20, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.6,
          ease: "power2.out",
          scrollTrigger: {
            trigger: title,
            start: "top 85%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }

    // Text animation
    if (text) {
      gsap.fromTo(
        text,
        { y: 20, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          delay: 0.15,
          duration: 0.6,
          ease: "power2.out",
          scrollTrigger: {
            trigger: text,
            start: "top 85%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }

    // Button animation (same style as others)
    if (button) {
      gsap.fromTo(
        button,
        { scale: 0.95, opacity: 0 },
        {
          scale: 1,
          opacity: 1,
          delay: 0.35,
          duration: 0.5,
          ease: "back.out(1.7)",
          scrollTrigger: {
            trigger: button,
            start: "top 85%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }
  }

  // Always refresh ScrollTrigger to ensure layout is measured correctly
  ScrollTrigger.refresh();
};

document.addEventListener("DOMContentLoaded", initMainCollectionAnimations);

// Observer setup
const collectionList = document.querySelector(".s-main-collection__list");
if (collectionList) {
  const observer = new MutationObserver(() => {
    // Delay slightly to ensure DOM is updated
    requestAnimationFrame(() => initMainCollectionAnimations());
  });

  observer.observe(collectionList, {
    childList: true,
    subtree: false,
  });
}
